import React from 'react';
import { AppTemplateProvidersProps } from './types/app-template-providers-props';
import { CoreProviders } from './app-template-providers';
import { DesktopOidcProvider } from '@revenuewell/logic-desktop-oidc';
import { useConfig } from '@revenuewell/logic-config';
import { OidcProvider } from '@revenuewell/logic-oidc';


export function PublicAppTemplateProviders(props: React.PropsWithChildren<AppTemplateProvidersProps>) {
  return (
    <CoreProviders  {...props}>
      <ConfigDependantProviders {...props}>
        {props.children}
      </ConfigDependantProviders>
    </CoreProviders>
  );
}

function ConfigDependantProviders(props: React.PropsWithChildren<AppTemplateProvidersProps>) {
  const { config } = useConfig()

  return (
    // todo: review why we started to use reference tokens for the desktop app
    // sign out issue for the desktop for the jwt token 
    <OidcProvider oidcConfig={/*isDesktopApplication() ? config.oidcDesktop :*/ config.oidc} checkSessionOnStart={false}>
      <DesktopOidcProvider>
        {props.children}
      </DesktopOidcProvider>
    </OidcProvider>
  );
}
